import { useGetConfig } from '@jotta/grpc-connect-client/config'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'
import { Redirect } from '@jotta/ui/Redirect'
import { ErrorPageNotFound } from '@jotta/ui/ErrorPageNotFound'
import { PublicLayout } from '../components/Layout/PublicLayout'

export function PrivacyRoute() {
  const { data } = useGetConfig()

  if (!data) {
    return <LoadingOverlay open />
  }

  const privacyLink = data.brandingInfo?.privacyLink
  return privacyLink ? (
    <Redirect to={privacyLink} />
  ) : (
    <PublicLayout section="not_found">
      <ErrorPageNotFound />
    </PublicLayout>
  )
}
